import React from "react";
import Parceiro from "../../components/classes/Parceiro";
import AcompanhamentoCargaGridCIF from "./gridCif";

import { confirmAlert } from "react-confirm-alert";
import { useNavigate } from "react-router-dom";

import { useTranslation } from "react-i18next";

export default function AcompanhamentoCargaDetalhes() {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const parceiro: Parceiro = JSON.parse(
    String(localStorage.getItem("ParceiroSelecionado"))
  );

  const validarParceiroSelecionado = () => {
    if (!parceiro)
      confirmAlert({
        title: t("pages.deliveriesCif.text.requiredField"),
        message: t("pages.deliveriesCif.text.selectPartnerFirst"),
        buttons: [{
          label: t("common.ok"), onClick: () => {
            navigate('/');
          }
        }]
      });

    return (
      parceiro ?
        <AcompanhamentoCargaGridCIF parceiro={parceiro} />
        :
        <div />
    );
  }

  return (validarParceiroSelecionado());
}
